
import { createFileRoute } from '@tanstack/react-router'
import { SignInWithBaseButton } from '../components/ui/base-pay/SignInWithBaseButton'
import { BasePayButton } from '../components/ui/base-pay/BasePayButton'
import { useBasePay } from '../hooks/useBasePay'

export const Route = createFileRoute('/base-pay-demo')({
    component: BasePayDemo,
})

function BasePayDemo() {
    const { initiatePayment, loading, error } = useBasePay()

    const handlePay = async () => {
        try {
            await initiatePayment({
                amount: '1.00',
                to: import.meta.env.VITE_MERCHANT_WALLET_ADDRESS || '0xRecipient',
                testnet: true
            })
            alert('Payment initiated!')
        } catch (e) {
            // Error is handled in hook/state
        }
    }

    return (
        <div className="p-8 max-w-2xl mx-auto space-y-8">
            <h1 className="text-3xl font-bold">Base Pay Integration Demo</h1>

            <section className="space-y-4">
                <h2 className="text-xl font-semibold">1. Sign In Button</h2>
                <div className="flex gap-4 p-4 border rounded-lg bg-gray-50 dark:bg-zinc-900">
                    <div className="space-y-2">
                        <p className="text-sm text-gray-500">Light Mode:</p>
                        <SignInWithBaseButton colorScheme="light" onClick={() => alert('Sign In Clicked')} />
                    </div>
                    <div className="space-y-2">
                        <p className="text-sm text-gray-500">Dark Mode:</p>
                        <SignInWithBaseButton colorScheme="dark" onClick={() => alert('Sign In Clicked')} />
                    </div>
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-semibold">2. Pay Button (One-Click)</h2>
                <div className="flex gap-4 p-4 border rounded-lg bg-gray-50 dark:bg-zinc-900">
                    <div className="space-y-2">
                        <p className="text-sm text-gray-500">Light Mode:</p>
                        <BasePayButton colorScheme="light" onClick={handlePay} />
                    </div>
                    <div className="space-y-2">
                        <p className="text-sm text-gray-500">Dark Mode:</p>
                        <BasePayButton colorScheme="dark" onClick={handlePay} />
                    </div>
                </div>
                {loading && <p className="text-blue-500">Processing...</p>}
                {error && <p className="text-red-500">Error: {error}</p>}
            </section>

            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-800">
                Note: Ensure you have a wallet installed and configured for Base Sepolia (Testnet) to test payments.
            </div>
        </div>
    )
}
